import request from 'services/request';
const URL_CATALOGS = '/Catalogs/Api/v1';
const FIXED_CATALOGS = `${URL_CATALOGS}/FixedCatalogs`;
const VALIDATORS_CATALOGS = '/Catalogs/Api/v1/Validators';

export const paramsSerializer = (params) => {
  let arrayCollection = [];
  let singleCollection = [];
  const paramsKeys = Object.keys(params);

  paramsKeys.forEach((param) => {
    const paramValue = params[param];

    //If the param value is an array
    if (paramValue?.length) {
      const collectionOfFormattedStrings = paramValue.map((value, index) => {
        return `${param}=${value}`;
      });
      arrayCollection = [collectionOfFormattedStrings, ...arrayCollection];
    } else {
      singleCollection = [`${param}=${paramValue}`, ...singleCollection];
    }
  });

  let urlString = '';

  arrayCollection.forEach((arrayOfSameParams) => {
    arrayOfSameParams.forEach((parameter) => {
      urlString = `${urlString}&${parameter}`;
    });
  });

  singleCollection.forEach((part) => {
    urlString = `${urlString}&${part}`;
  });

  return urlString;
};

export async function getPoliciesCatalog({ cancelToken }) {
  let uri = `/Agreements/Api/v1/Catalogs/Policies`;
  return request(uri, {
    method: 'GET',
    cancelToken,
  });
}

export async function getFixedCatalogByName({ cancelToken, catalogName, params, mode }) {
  let uri = `${FIXED_CATALOGS}/${catalogName}`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    paramsSerializer: mode === 'multiple' ? paramsSerializer : undefined,
    params,
  });
}

export async function getCatalogByName({ cancelToken, catalogName, params, mode }) {
  let uri = `${URL_CATALOGS}/${catalogName}`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    paramsSerializer: mode === 'multiple' ? paramsSerializer : undefined,
    params,
  });
}

//fixedCatalogs

export async function getFixedCatalogProcessYears({ cancelToken }) {
  let uri = `${FIXED_CATALOGS}/ProcessYears`;
  return request(uri, {
    method: 'GET',
    cancelToken,
  });
}
export async function getFixedCatalogRegions({ cancelToken }) {
  let uri = `${FIXED_CATALOGS}/Regions`;
  return request(uri, {
    method: 'GET',
    cancelToken,
  });
}

//validators

export async function getClientsForValidators({ cancelToken, params }) {
  // /Catalogs/Api/v1/Clients/ClientsForValidators/{lineId}
  let uri = `/Catalogs/Api/v1/Clients/ClientsForValidatorsSellIn`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    params,
  });
}
export async function getClientsForValidatorsSellOut({ cancelToken, params }) {
  // /Catalogs/Api/v1/Clients/ClientsForValidators/{lineId}
  let uri = `/Catalogs/Api/v1/Clients/ClientsForValidatorsSellOut`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    params,
  });
}
export async function getZonesForValidators({ cancelToken, params }) {
  // /Catalogs/Api/v1/Validators/GetZonesValidator
  let uri = `${VALIDATORS_CATALOGS}/GetZonesValidator`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    params,
    paramsSerializer,
  });
}

export async function getTerritoriesForValidators({ cancelToken, params }) {
  // /Catalogs/Api/v1/Validators/GetTerritoriesValidators
  let uri = `${VALIDATORS_CATALOGS}/GetTerritoriesValidators`;
  return request(uri, {
    method: 'GET',
    cancelToken,
    params,
  });
}
